module.exports = __webpack_public_path__ + "static/media/whatsappscan.474b72aa.jpg";